import React, { Fragment, useEffect } from "react"
import useTitle from "../../../../modules/hooks/useTitle";
export default props => {
  const { searchList, request262 } = props;

  return (
    <div className="pr-section">
      <div className="allergy-search">
        <div>
          <input
            type="text"
            id="searchVal"
            className="textbox"
            placeholder="약품(제품)명 또는 성분명을 검색해 주세요"
            onKeyUp={e => {
              if (window.event.keyCode == 13) {
                request262("", $("#searchVal").val());
              }
            }}
          />
          <a onClick={() => request262("", $("#searchVal").val())}></a>
        </div>
      </div>
    </div>
  );
};

export const SearchList = props => {
  const { searchList, openDetailPopup, openAddPopup } = props;

  let medicineName = searchList.medicineName;

  if (medicineName.length > 11) {
    medicineName = medicineName.substring(0, 11) + "...";
  }
  return (
    // <div className="allergy-line-box">
    //     <ul>
    //         <li>
    //             <strong>{medicineName}</strong>
    //             <button className="btn_search" onClick={()=>openDetailPopup('00', searchList.medicineId, searchList.medicineName)}></button>
    //             <button className="btn_add" onClick={()=>openAddPopup('00', searchList.medicineId, searchList.medicineName)}></button>
    //         </li>
    //         <li>
    //             <strong >성분명 : </strong>
    //             <span>{searchList.IngredientName}</span>
    //         </li>
    //     </ul>
    // </div>

    <div>
      <ContentsList
        list={searchList}
        title={searchList.medicineName}
        allergyType="00"
        targetId={searchList.medicineId}
        targetName={searchList.medicineName}
        openAddPopup={openAddPopup}
        openDetailPopup={openDetailPopup}
        key={"c" + i}
      />
      {/* <label disabled><input type="radio" name="radio01" onClick={()=>openAddPopup('00', searchList.medicineId, searchList.medicineName)} /><i></i></label>
            <div className="inbox">
                <b>{medicineName}</b><a className="loc search" onClick={()=>openDetailPopup('00', searchList.medicineId, searchList.medicineName)}></a>
                {
                    searchList.IngredientName && <p>성분명: {searchList.IngredientName}</p>
                }
                {/* <p>031-123-1234  <span>현재위치 800m</span></p> */}
      {/* </div> */}
    </div>
  );
};

export const SearchDefaultMdcn = props => {
  const { openDetailPopup, openAddPopup, allergyType } = props;

  const defaultList = [
    {
      foodId: "01",
      foodName: "피린계열 알레르기",
    },
    {
      foodId: "02",
      foodName: "페니실린 알레르기",
    },
    {
      foodId: "03",
      foodName: "세파계 알레르기",
    },
    {
      foodId: "04",
      foodName: "아스피린계 알레르기",
    },
    {
      foodId: "05",
      foodName: "비스테로이드성 소염진통제 알레르기",
    },
  ];

  const warningList = [
    {
      foodId: "21",
      foodName: "임산부 주의약품",
    },
    {
      foodId: "22",
      foodName: "파킨슨 주의약품",
    },
  ];
  // allergyType => 0:일반 2:주의약품 1:식품 9:기타
  // openAddPopup(foodId, medicineId, medicineName);
  return (
    <Fragment>
      {/* <div className="wbox-select-list"> */}
      {allergyType === 0
        ? defaultList.length > 0 &&
          defaultList.map((m, i) => (
            // <div style={{paddingBottom:"4px"}} key={"dfList"+i}>
            //     <input type="radio" className="radio_green" id={m.foodId} value={m.foodName} name="defaultList" onClick={()=>openAddPopup(m.foodId, '', m.foodName)}/><i></i>
            //     <label htmlFor={m.foodId}>{m.foodName}</label>
            //     <button className="btn_search_end" onClick={()=>openDetailPopup(m.foodId, '', m.foodName)}></button>
            // </div>
            <ContentsList
              list={m}
              title={m.foodName}
              allergyType={m.foodId}
              targetId=""
              targetName={m.foodName}
              openAddPopup={openAddPopup}
              openDetailPopup={openDetailPopup}
              key={"a" + i}
            />
          ))
        : warningList.length > 0 &&
          warningList.map((m, i) => (
            // <div style={{paddingBottom:"4px"}} key={"dfList"+i}>
            //     <input type="radio" className="radio_green" id={m.foodId} value={m.foodName} name="defaultList" onClick={()=>openAddPopup(m.foodId, '', m.foodName)}/><i></i>
            //     <label htmlFor={m.foodId}>{m.foodName}</label>
            //     <button className="btn_search_end" onClick={()=>openDetailPopup(m.foodId, '', m.foodName)}></button>
            // </div>
            <ContentsList
              list={m}
              title={m.foodName}
              allergyType={m.foodId}
              targetId=""
              targetName={m.foodName}
              openAddPopup={openAddPopup}
              openDetailPopup={openDetailPopup}
              key={"b" + i}
            />
          ))}
      {/* </div> */}
    </Fragment>
  );
};

export const ContentsList = props => {
  const {
    list,
    title,
    allergyType,
    targetId,
    targetName,
    openAddPopup,
    openDetailPopup,
  } = props;

  let titleTxt = title;

  // if(titleTxt.length > 11) {
  //     titleTxt = titleTxt.substring(0,11) + "...";
  // }

  return (
    <div>
      <label style={{ width: "26%" }}>
        <input
          type="button"
          value="추가하기"
          onClick={() => openAddPopup(allergyType, targetId, targetName)}
          style={{
            display: "block",
            position: "absolute",
            top: "50%",
            marginTop: "-14px",
            background: "#b2bee5",
            borderRadius: "5px",
            border: "0",
            width: "70px",
            height: "28px",
            color: "#fff",
          }}
        />
      </label>

      <div className="inbox">
        <div style={{ width: "70%" }}>
          <b>{titleTxt}</b>
          <a
            className="loc detail"
            onClick={() =>
              openDetailPopup(allergyType, targetId, targetName)
            }></a>
          {list.IngredientName && <p>성분명: {list.IngredientName}</p>}
        </div>
      </div>
    </div>
  );
};

export const AllergyImgList = props => {
  const { type, openAddPopup, allergyType } = props;

  return (
    <div className="list_area_img">
      <ul>
        {type.map((list, i) => (
          <li key={i} onClick={() => openAddPopup(list.code, "", list.text)}>
            <a className="food_view_pop">
              <span className={list.img}></span>
              <strong className="alg_txt">{list.text}</strong>
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
};